// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-product__wrapper {
	background-color: var(--background);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 40px;
	width: 100%;
	padding: 80px 0;
}

.catalog-product__content {
	max-width: 1340px;
	padding: 0 20px;
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 24px;
}

.catalog-product__information-block {
	display: grid;
	grid-template-columns: 400px 1fr;
	gap: 24px;
}

.catalog-product__carousel-image {
	border: 1px solid var(--border-transparent);
	border-radius: 8px;
	width: 100%;
	aspect-ratio: 1 / 1;
}

.catalog-product__carousel-image.empty {
	width: 100%;
	aspect-ratio: 1 / 1;
}

.catalog-product__images-wrapper {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.catalog-product__variants-list {
	display: flex;
	gap: 8px;
	overflow-y: auto;
}

.catalog-product__variant-image-active {
	width: 70px;
	height: 70px;
	min-width: 70px;
	aspect-ratio: 1 / 1;
	border-radius: 5px;
	cursor: pointer;
	border: 2px solid var(--button);
	overflow: hidden;
}

.catalog-product__variant-image-active img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.catalog-product__variant-image {
	width: 70px;
	height: 70px;
	min-width: 70px;
	aspect-ratio: 1 / 1;
	border-radius: 5px;
	cursor: pointer;
	border: 2px solid var(--gray);
	overflow: hidden;
}

.catalog-product__variant-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.catalog-product__details-block {
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.catalog-product__details-title {
	font-size: 28px;
	line-height: 36px;
	font-weight: 500;
}

.catalog-product__details-price-block {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
}

.catalog-product__details-price {
	font-size: 26px;
	line-height: 32px;
	font-weight: 500;
}

.catalog-product__details-sku {
	font-size: 26px;
	line-height: 32px;
	color: var(--border-transparent);
	text-transform: uppercase;
}

.catalog-product__description-block {
	display: flex;
	flex-direction: column;
	border-top: 1px solid var(--border-transparent);
	padding-top: 24px;
}

.catalog-product__description {
	font-size: 16px;
	line-height: 24px;
	color: var(--text);
}

.catalog-product__customer-reviews-block {
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
	max-width: 1340px;
	padding: 0 20px;
	padding-top: 30px;
}

.catalog-product__reviews-title {
	font-size: 24px;
	line-height: 32px;
	font-weight: 500;
}

.catalog-product__no-reviews-text {
	font-size: 16px;
	line-height: 24px;
	color: var(--text);
	width: 100%;
	border: 1px solid var(--border-transparent);
	border-radius: 12px;
	padding: 40px 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	font-weight: 500;
}

.catalog-product__review-item {
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 20px;
	border: 1px solid var(--border-transparent);
	border-radius: 12px;
}

.catalog-product__review-author-block {
	display: flex;
	align-items: center;
	gap: 8px;
	justify-content: space-between;
}

.catalog-product__review-author {
	font-size: 16px;
	line-height: 20px;
	font-weight: 600;
}

.catalog-product__review-date {
	font-size: 16px;
	line-height: 20px;
	color: var(--border-transparent);
}

.catalog-product__review-rating-block {
	margin-top: -8px;
}

.catalog-product__review-title {
	font-size: 18px;
	line-height: 24px;
	font-weight: 500;
	margin-top: 16px;
}

.catalog-product__review-content {
	font-size: 15px;
	line-height: 23px;
	color: var(--text);
}

@media (max-width: 1150px) {
	.catalog-product__information-block {
		display: grid;
		grid-template-columns: 350px 1fr;
		gap: 24px;
	}
}

@media (max-width: 950px) {
	.catalog-product__wrapper {
		background-color: var(--background);
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 30px;
		width: 100%;
		padding: 30px 0;
	}

	.catalog-product__content {
		max-width: 1340px;
		padding: 0 20px;
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: 16px;
	}

	.catalog-product__information-block {
		display: grid;
		grid-template-columns: 1fr;
		gap: 16px;
	}

	.catalog-product__variant-image-active {
		width: 50px;
		height: 50px;
		min-width: 50px;
		aspect-ratio: 1 / 1;
		border-radius: 5px;
		cursor: pointer;
		border: 2px solid var(--button);
		overflow: hidden;
	}

	.catalog-product__variant-image {
		width: 50px;
		height: 50px;
		min-width: 50px;
		aspect-ratio: 1 / 1;
		border-radius: 5px;
		cursor: pointer;
		border: 2px solid var(--gray);
		overflow: hidden;
	}

	.catalog-product__details-title {
		font-size: 20px;
		line-height: 28px;
		font-weight: 500;
	}

	.catalog-product__details-price-block {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
	}

	.catalog-product__details-price {
		font-size: 18px;
		line-height: 24px;
		font-weight: 500;
	}

	.catalog-product__details-sku {
		font-size: 18px;
		line-height: 24px;
		color: var(--border-transparent);
		text-transform: uppercase;
	}

	.catalog-product__customer-reviews-block {
		display: flex;
		flex-direction: column;
		gap: 16px;
		width: 100%;
		max-width: 1340px;
		padding: 0 20px;
		padding-top: 0;
	}

	.catalog-product__reviews-title {
		font-size: 18px;
		line-height: 24px;
		font-weight: 500;
	}

	.catalog-product__review-title {
		font-size: 16px;
		line-height: 24px;
		font-weight: 500;
		margin-top: 12px;
	}

	.catalog-product__no-reviews-text {
		font-size: 16px;
		line-height: 24px;
		color: var(--text);
		width: 100%;
		border: 1px solid var(--border-transparent);
		border-radius: 12px;
		padding: 30px 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;
		font-weight: 500;
		text-align: center;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/LendingPage/Catalog/CatalogProduct/CatalogProduct.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;CACT,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,SAAS;AACV;;AAEA;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gCAAgC;CAChC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,+CAA+C;CAC/C,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;CACX,2CAA2C;CAC3C,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,aAAa;CACb,2CAA2C;CAC3C,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,8BAA8B;AAC/B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC;EACC,aAAa;EACb,gCAAgC;EAChC,SAAS;CACV;AACD;;AAEA;CACC;EACC,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;CAChB;;CAEA;EACC,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;CACV;;CAEA;EACC,aAAa;EACb,0BAA0B;EAC1B,SAAS;CACV;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;CACV;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;CAC1B;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;CACf;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;CACnB;AACD","sourcesContent":[".catalog-product__wrapper {\n\tbackground-color: var(--background);\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 40px;\n\twidth: 100%;\n\tpadding: 80px 0;\n}\n\n.catalog-product__content {\n\tmax-width: 1340px;\n\tpadding: 0 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tgap: 24px;\n}\n\n.catalog-product__information-block {\n\tdisplay: grid;\n\tgrid-template-columns: 400px 1fr;\n\tgap: 24px;\n}\n\n.catalog-product__carousel-image {\n\tborder: 1px solid var(--border-transparent);\n\tborder-radius: 8px;\n\twidth: 100%;\n\taspect-ratio: 1 / 1;\n}\n\n.catalog-product__carousel-image.empty {\n\twidth: 100%;\n\taspect-ratio: 1 / 1;\n}\n\n.catalog-product__images-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n}\n\n.catalog-product__variants-list {\n\tdisplay: flex;\n\tgap: 8px;\n\toverflow-y: auto;\n}\n\n.catalog-product__variant-image-active {\n\twidth: 70px;\n\theight: 70px;\n\tmin-width: 70px;\n\taspect-ratio: 1 / 1;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\tborder: 2px solid var(--button);\n\toverflow: hidden;\n}\n\n.catalog-product__variant-image-active img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.catalog-product__variant-image {\n\twidth: 70px;\n\theight: 70px;\n\tmin-width: 70px;\n\taspect-ratio: 1 / 1;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\tborder: 2px solid var(--gray);\n\toverflow: hidden;\n}\n\n.catalog-product__variant-image img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.catalog-product__details-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n}\n\n.catalog-product__details-title {\n\tfont-size: 28px;\n\tline-height: 36px;\n\tfont-weight: 500;\n}\n\n.catalog-product__details-price-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 16px;\n}\n\n.catalog-product__details-price {\n\tfont-size: 26px;\n\tline-height: 32px;\n\tfont-weight: 500;\n}\n\n.catalog-product__details-sku {\n\tfont-size: 26px;\n\tline-height: 32px;\n\tcolor: var(--border-transparent);\n\ttext-transform: uppercase;\n}\n\n.catalog-product__description-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tborder-top: 1px solid var(--border-transparent);\n\tpadding-top: 24px;\n}\n\n.catalog-product__description {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: var(--text);\n}\n\n.catalog-product__customer-reviews-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n\twidth: 100%;\n\tmax-width: 1340px;\n\tpadding: 0 20px;\n\tpadding-top: 30px;\n}\n\n.catalog-product__reviews-title {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 500;\n}\n\n.catalog-product__no-reviews-text {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: var(--text);\n\twidth: 100%;\n\tborder: 1px solid var(--border-transparent);\n\tborder-radius: 12px;\n\tpadding: 40px 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 16px;\n\tfont-weight: 500;\n}\n\n.catalog-product__review-item {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n\tpadding: 20px;\n\tborder: 1px solid var(--border-transparent);\n\tborder-radius: 12px;\n}\n\n.catalog-product__review-author-block {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tjustify-content: space-between;\n}\n\n.catalog-product__review-author {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tfont-weight: 600;\n}\n\n.catalog-product__review-date {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: var(--border-transparent);\n}\n\n.catalog-product__review-rating-block {\n\tmargin-top: -8px;\n}\n\n.catalog-product__review-title {\n\tfont-size: 18px;\n\tline-height: 24px;\n\tfont-weight: 500;\n\tmargin-top: 16px;\n}\n\n.catalog-product__review-content {\n\tfont-size: 15px;\n\tline-height: 23px;\n\tcolor: var(--text);\n}\n\n@media (max-width: 1150px) {\n\t.catalog-product__information-block {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 350px 1fr;\n\t\tgap: 24px;\n\t}\n}\n\n@media (max-width: 950px) {\n\t.catalog-product__wrapper {\n\t\tbackground-color: var(--background);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 30px;\n\t\twidth: 100%;\n\t\tpadding: 30px 0;\n\t}\n\n\t.catalog-product__content {\n\t\tmax-width: 1340px;\n\t\tpadding: 0 20px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\tgap: 16px;\n\t}\n\n\t.catalog-product__information-block {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 16px;\n\t}\n\n\t.catalog-product__variant-image-active {\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tmin-width: 50px;\n\t\taspect-ratio: 1 / 1;\n\t\tborder-radius: 5px;\n\t\tcursor: pointer;\n\t\tborder: 2px solid var(--button);\n\t\toverflow: hidden;\n\t}\n\n\t.catalog-product__variant-image {\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tmin-width: 50px;\n\t\taspect-ratio: 1 / 1;\n\t\tborder-radius: 5px;\n\t\tcursor: pointer;\n\t\tborder: 2px solid var(--gray);\n\t\toverflow: hidden;\n\t}\n\n\t.catalog-product__details-title {\n\t\tfont-size: 20px;\n\t\tline-height: 28px;\n\t\tfont-weight: 500;\n\t}\n\n\t.catalog-product__details-price-block {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tgap: 16px;\n\t}\n\n\t.catalog-product__details-price {\n\t\tfont-size: 18px;\n\t\tline-height: 24px;\n\t\tfont-weight: 500;\n\t}\n\n\t.catalog-product__details-sku {\n\t\tfont-size: 18px;\n\t\tline-height: 24px;\n\t\tcolor: var(--border-transparent);\n\t\ttext-transform: uppercase;\n\t}\n\n\t.catalog-product__customer-reviews-block {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 16px;\n\t\twidth: 100%;\n\t\tmax-width: 1340px;\n\t\tpadding: 0 20px;\n\t\tpadding-top: 0;\n\t}\n\n\t.catalog-product__reviews-title {\n\t\tfont-size: 18px;\n\t\tline-height: 24px;\n\t\tfont-weight: 500;\n\t}\n\n\t.catalog-product__review-title {\n\t\tfont-size: 16px;\n\t\tline-height: 24px;\n\t\tfont-weight: 500;\n\t\tmargin-top: 12px;\n\t}\n\n\t.catalog-product__no-reviews-text {\n\t\tfont-size: 16px;\n\t\tline-height: 24px;\n\t\tcolor: var(--text);\n\t\twidth: 100%;\n\t\tborder: 1px solid var(--border-transparent);\n\t\tborder-radius: 12px;\n\t\tpadding: 30px 20px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 16px;\n\t\tfont-weight: 500;\n\t\ttext-align: center;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
